import React from 'react';
import PropTypes from 'prop-types'

const Title = ({ text, classList }) => <h1 className={classList}>{text}</h1>

Title.prototype = {
  text: PropTypes.string.isRequired,
  classList: PropTypes.string.isRequired,
}

export default Title;